<p-toolbar id="app-header" styleClass="app-header" (mouseenter)="hideAllOverlays()">
    <div class="p-toolbar-group-left">
        <div id="sidebar-header">
            <a [routerLink]="'/'">
                <img src="assets/images/app-logo.svg" id="app-logo" alt="app-logo" />
            </a>
            <div>
                <p id="app-title">YX Admin</p>
                <p id="app-subtitle">Transnetyx</p>
            </div>
        </div>
    </div>

    <div class="p-toolbar-group-center">
        <h3 [hidden]="!currentUser">Welcome Back, {{ currentUser?.firstName }}!</h3>
    </div>

    <div class="p-toolbar-group-right">
        <app-toolbar></app-toolbar>
    </div>
</p-toolbar>

<div id="app-navigation">
    <ng-container *ngFor="let item of appNavigation">
        <a
            *ngIf="item.internalRoute"
            (mouseenter)="navItemHover(item.id, $event)"
            class="nav-item"
            [id]="'nav-item-' + item.id"
            [routerLink]="item.url"
            [routerLinkActive]="['active-link']"
            [routerLinkActiveOptions]="{ exact: false }">
            <span>{{ item.name }}</span>
        </a>
        <a
            *ngIf="!item.internalRoute"
            (mouseenter)="navItemHover(item.id, $event)"
            class="nav-item"
            [id]="'nav-item-' + item.id"
            [href]="item.url">
            <span>{{ item.name }}</span>
        </a>
    </ng-container>
</div>

<p-overlayPanel #ovAccounts styleClass="overlay" [focusOnShow]="true">
    <div (mouseleave)="hideAllOverlays()" class="overlay">
        <div class="overlay-body">
            <a [href]="submenu.url" *ngFor="let submenu of accountsSubmenu" [id]="submenu.id">{{ submenu.name }}</a>
        </div>
    </div>
</p-overlayPanel>

<p-overlayPanel #ovAssays styleClass="overlay" [focusOnShow]="true">
    <div (mouseleave)="hideAllOverlays()" class="overlay">
        <div class="overlay-body">
            <a [href]="submenu.url" *ngFor="let submenu of assaysSubmenu" [id]="submenu.id">{{ submenu.name }}</a>
        </div>
    </div>
</p-overlayPanel>

<p-overlayPanel #ovOrders styleClass="overlay" [focusOnShow]="true">
    <div (mouseleave)="hideAllOverlays()" class="overlay">
        <div class="overlay-body">
            <a [href]="submenu.url" *ngFor="let submenu of ordersSubmenu" [id]="submenu.id">{{ submenu.name }}</a>
        </div>
    </div>
</p-overlayPanel>

<p-overlayPanel #ovPricing styleClass="overlay" [focusOnShow]="true">
    <div (mouseleave)="hideAllOverlays()" class="overlay">
        <div class="overlay-body">
            <a [href]="submenu.url" *ngFor="let submenu of pricingSubmenu" [id]="submenu.id">{{ submenu.name }}</a>
        </div>
    </div>
</p-overlayPanel>

<p-overlayPanel #ovProbes styleClass="overlay" [focusOnShow]="true">
    <div (mouseleave)="hideAllOverlays()" class="overlay">
        <div class="overlay-body">
            <a [href]="submenu.url" *ngFor="let submenu of probesSubmenu" [id]="submenu.id">{{ submenu.name }}</a>
        </div>
    </div>
</p-overlayPanel>

<p-overlayPanel #ovPm styleClass="overlay" [focusOnShow]="true">
    <div (mouseleave)="hideAllOverlays()" class="overlay">
        <div class="overlay-body">
            <a [href]="submenu.url" *ngFor="let submenu of pmSubmenu" [id]="submenu.id">{{ submenu.name }}</a>
        </div>
    </div>
</p-overlayPanel>

<p-overlayPanel #ovSales styleClass="overlay" [focusOnShow]="true">
    <div (mouseleave)="hideAllOverlays()" class="overlay">
        <div class="overlay-body">
            <a [href]="submenu.url" *ngFor="let submenu of salesSubmenu" [id]="submenu.id">{{ submenu.name }}</a>
        </div>
    </div>
</p-overlayPanel>

<p-overlayPanel #ovShipping styleClass="overlay" [focusOnShow]="true">
    <div (mouseleave)="hideAllOverlays()" class="overlay">
        <div class="overlay-body">
            <a [href]="submenu.url" *ngFor="let submenu of shippingSubmenu" [id]="submenu.id">{{ submenu.name }}</a>
        </div>
    </div>
</p-overlayPanel>

<p-overlayPanel #ovStrains styleClass="overlay" [focusOnShow]="true">
    <div (mouseleave)="hideAllOverlays()" class="overlay">
        <div class="overlay-body">
            <a [href]="submenu.url" *ngFor="let submenu of strainsSubmenu" [id]="submenu.id">{{ submenu.name }}</a>
        </div>
    </div>
</p-overlayPanel>

<p-overlayPanel #ovTagCenter styleClass="overlay" [focusOnShow]="true">
    <div (mouseleave)="hideAllOverlays()" class="overlay">
        <div class="overlay-body">
            <a [href]="submenu.url" *ngFor="let submenu of tagCenterSubmenu" [id]="submenu.id">{{ submenu.name }}</a>
        </div>
    </div>
</p-overlayPanel>
